import { IPxHeightData } from "./height-data";
import { IBorderRadiusData, IFontData, IInteractiveElementColorData, IWidgetVisibility, VisibilityData, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface ISearchBarWidgetData extends IWidgetVisibility {
    readonly type: "SearchBarWidget";
    id?: string | null;
    placeType: WidgetPlaceType;
    placeholder: string;
    quickSearch: boolean;
    style: ISearchBarWidgetStyle;
    layout: SearchBarLayoutType;
}

export interface ISearchBarWidgetStyle extends IAnimatedWidget {
    heightData: IPxHeightData;
    inputStyle: ISearchBarInputStyle;
}

export interface ISearchBarInputStyle {
    iconColor?: string | null,
    buttonColor: IInteractiveElementColorData,
    backgroundColor: IInteractiveElementColorData;
    borderColor: IInteractiveElementColorData;
    borderThickness: number;
    borderRadius: IBorderRadiusData;
    textFont: IFontData;
    placeholderColor: IInteractiveElementColorData;
}

export type SearchBarLayoutType = "without-icon" | "icon-start" | "icon-end" | "filled-icon-start" | "filled-icon-end";

export abstract class SearchBarWidgetData {

    public static get defaultData(): ISearchBarWidgetData {
        return {
            type: "SearchBarWidget",
            placeType: "Section",
            placeholder: "Search...",
            quickSearch: true,
            style: this.defaultStyle,
            visibility: VisibilityData.defaultData(),
            layout: "icon-end"
        };
    }

    public static get defaultStyle(): ISearchBarWidgetStyle {
        return {
            heightData: {
                height: 40
            },
            inputStyle: {
                iconColor: null,
                buttonColor: {
                    colorDefault: null,
                    colorHovered: null
                },
                backgroundColor: {
                    colorDefault: "#FFFFFF",
                    colorHovered: "#FFFFFF",
                },
                borderThickness: 1,
                borderColor: {
                    colorDefault: "#C1C1C1",
                    colorHovered: "#C1C1C1",
                },
                borderRadius: {
                    topLeftPx: 0,
                    topRightPx: 0,
                    bottomLeftPx: 0,
                    bottomRightPx: 0
                },
                textFont: {
                    family: "Open Sans",
                    weight: "400",
                    color: "#3E3E3E"
                },
                placeholderColor: {
                    colorDefault: "#C1C1C1",
                    colorHovered: "#C1C1C1",
                }
            },
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

    private static get defaultLayoutStyleIconStartIconEnd(): ISearchBarWidgetStyle {
        return {
            ...this.defaultStyle,
            inputStyle: {
                ...this.defaultStyle.inputStyle,
                iconColor: "#7B828E"
            }
        };
    }

    private static get defaultLayoutStyleFilledIconStartFilledIconEnd(): ISearchBarWidgetStyle {
        return {
            ...this.defaultStyle,
            inputStyle: {
                ...this.defaultStyle.inputStyle,
                iconColor: "#FFFFFF",
                buttonColor: {
                    colorDefault: "#12A3F8",
                    colorHovered: "#0686D1"
                }
            }
        };
    }

    public static getDefaultLayoutStyle(layout: SearchBarLayoutType): ISearchBarWidgetStyle {
        switch(layout){
            case "without-icon":
                return this.defaultStyle;
            case "icon-start":
            case "icon-end":
                return this.defaultLayoutStyleIconStartIconEnd;
            case "filled-icon-start":
            case "filled-icon-end":
                return this.defaultLayoutStyleFilledIconStartFilledIconEnd;
            default:
                return this.defaultStyle;
        }
    }

}
